module.exports = __webpack_public_path__ + "img/gpbp.99c3a786.jpg";